/**
 * Identifies the dimensionality of a measurement in terms of what
 * type of dimensions are being measured by the value.
 */
export enum MeasurementType {
  Linear = 'Linear',
  Area = 'Area',
  Volume = 'Volume',
  Pixel = 'Pixel',
}
